import React, { createContext, FC, ReactNode, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getUserDataWithUsername, IUserProps } from '../common/data/userDummyData';

export interface IAuthContextProps {
	user: string;
	setUser: React.Dispatch<React.SetStateAction<string>>;
	setUserData: (data: any) => void;
	userData: Partial<IUserProps>;
}

const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
	children: ReactNode;
}

export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
	const [user, setUser] = useState<string>('');
	const [userData, setUserData] = useState<any>(null);

	// You can use useEffect to persist `user` in localStorage if needed
	// useEffect(() => {
	//   localStorage.setItem('auth', user);
	// }, [user]);

	// Example: Set userData when user changes
	// useEffect(() => {
	//   if (user !== '') {
	//     setUserData(getUserDataWithUsername(user));
	//   } else {
	//     setUserData({});
	//   }
	// }, [user]);

	const value = useMemo(
		() => ({
			user,
			setUser,
			setUserData,
			userData,
		}),
		[user, setUser, setUserData, userData],
	);

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// PropTypes validation for children prop
AuthContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AuthContext;
